import { onDomReady } from './helpers';

function initLightbox() {
    const galleryItems = document.querySelectorAll('.wp-block-gallery .wp-block-image');

    if (galleryItems.length > 0) {
        galleryItems.forEach(item => {
            const imgSrc = item.querySelector('img').src;
            const orgHtml = item.innerHTML;
            // eslint-disable-next-line require-unicode-regexp
            const newHtml = `<a data-fslightbox='gallery' href='${imgSrc.replace(/http\b/g, 'https')}'>${orgHtml}</a>`;
            item.innerHTML = newHtml;
        });
    }
    require('fslightbox');
}

onDomReady(() => {
    initLightbox();
})
